import { useEffect } from 'react';

const ChatWidget = () => {
  useEffect(() => {
    // Remove any existing widget script
    const existingScript = document.querySelector('script[src*="buildmyagent.io"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Remove any existing widget containers
    const existingContainers = document.querySelectorAll('[id*="ai-chat-widget"]');
    existingContainers.forEach(container => container.remove());

    // Remove any existing widget iframes
    const existingIframes = document.querySelectorAll('iframe[src*="buildmyagent.io"]');
    existingIframes.forEach(iframe => iframe.remove());

    // Load the Icelandic widget
    const script = document.createElement('script');
    script.src = 'https://buildmyagent.io/widget/6907ed39fd08514d97f68197/widget.js?widgetId=6907ed39fd08514d97f68197';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup on unmount
      const scriptToRemove = document.querySelector('script[src*="buildmyagent.io"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
      const containersToRemove = document.querySelectorAll('[id*="ai-chat-widget"]');
      containersToRemove.forEach(container => container.remove());
      const iframesToRemove = document.querySelectorAll('iframe[src*="buildmyagent.io"]');
      iframesToRemove.forEach(iframe => iframe.remove());
    };
  }, []);

  return null;
};

export default ChatWidget;
